import { IFile } from './file';
import { IMultiPolygon, IPoint, IPolygon } from './geo';

export enum AgencyType {
  EMS = 'EMS',
  FIRE = 'FIRE',
  POLICE = 'POLICE',
  EMERGENCY_MANAGEMENT = 'EMERGENCY_MANAGEMENT',
  MUNICIPAL_SERVICES = 'MUNICIPAL_SERVICES',
}
// TODO: superunhappy with this, move it to common be in the next PR
export enum PrePlanType {
  MDF = 'MDF',
}

export interface IAgency {
  _id?: string;
  name: string;
  phoneNumber?: string;
  email?: string;
  code: string;
  abbreviation?: string;
  type: AgencyType;
  oriNumber?: string;
  area?: IPolygon | IMultiPolygon;
  center?: IPoint;
  account?: {
    _id: string;
    number: string;
    settings: {
      features: {
        isEnabledJSMModule?: boolean;
      };
    };
  };
  isEnabledJMS?: boolean | string;
  isEnabledComplaintPolicy?: boolean | string;
  isOfficeChatEnabled?: boolean | string;
  isEnabledCreateCaseFromCfs?: boolean | string;
  isEnabledCreateStandaloneCases?: boolean | string;
  isEnabledSkydioEmailIntegration?: boolean | string;
  logo?: IFile;
  addressPrePlanType: any;
  address?: {
    address1: string;
    address2?: string;
    city: string;
    state: string;
    zipcode: string;
  };
  neris?: {
    stationId?: string;
    hasFireKasesIncidents?: boolean;
  };
}

export interface IAgencyForm extends Omit<IAgency, 'area'> {
  area: string;
  file?: string;
}
